/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2017, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import SmartsRecommenderError from './SmartsRecommenderError';
import SmartsRecommenderStatus from './SmartsRecommenderStatus';

class SmartsRecommenderService {
	constructor(options) {
		this.ajaxSvc = options.ajaxSvc || (options.dashboardApi && options.dashboardApi.getGlassCoreSvc ? options.dashboardApi.getGlassCoreSvc('.Ajax') : {});
		this.logger = options.logger || {
			debug: function(){},
			error: function(){}
		};
		// This request name is displayed on console, not to end user, so no need to localize
		this.requestName = options.requestName || '';
	}

	_executeRequest(data, requestURL){
		const requestPayload = {
			type: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			data: JSON.stringify(data),
			processData: false,
			url: requestURL
		};

		return this.ajaxSvc.ajax(requestPayload);
	}

	_processResponse(ajaxResponse){
		const recommenderResponse = ajaxResponse.data;
		if (this._isSucessfulResponse(recommenderResponse)) {
			return recommenderResponse.recommendation.recommendedFields;
		} else {
			throw this._createError({
				smartsCode: recommenderResponse && recommenderResponse.status ? recommenderResponse.status.statusCode : null,
				responseMessage: recommenderResponse&& recommenderResponse.status ? recommenderResponse.status.message : null
			});
		}
	}

	_isSucessfulResponse(smartsResponse) {
		return smartsResponse && smartsResponse.status && smartsResponse.status.statusCode === SmartsRecommenderStatus.COMPLETED;
	}

	_createError(options) {
		// this error is not displayed to user, do not need to localize
		const errorCode = options.httpCode || options.smartsCode;
		this.logger.error( `this.requestName ${options.code}: ${errorCode} ${options.responseMessage}`);
		options.requestName = this.requestName;
		const errorObj = new SmartsRecommenderError(options);
		const userMessages = this._getUserMessages(errorCode);
		if(userMessages){
			errorObj.setUserStrings(userMessages.title, userMessages.description);
		}
		return errorObj;
	}

	_handleError(ajaxError){
		const ERROR_CODE = 'EXPLORE_SMARTS_REQUEST_ERROR';//Localization not needed, debugging use only
		const ERROR_MSG = 'Error occured after explore sends request to smarts service.';//Localization not needed, debugging use only
		const responseJSON = ajaxError.jqXHR && ajaxError.jqXHR.responseJSON;
		if (responseJSON) {
			this.logger.debug(responseJSON);
			throw this._createError({
				smartsCode: responseJSON.status ? responseJSON.status.statusCode : ERROR_CODE,
				responseMessage: responseJSON.status? responseJSON.status.message: ERROR_MSG
			});
		} else {
			const errorObj = ajaxError.jqXHR && ajaxError.jqXHR.error && ajaxError.jqXHR.error();
			const statusCode = errorObj && errorObj.status ? errorObj.status : ERROR_CODE;
			const msg = errorObj && errorObj.responseText ? errorObj.responseText : ERROR_MSG;
			throw this._createError({
				httpCode: statusCode,//TODO: Not all errors thrown from the request are ajaxError that have HTTP Codes
				responseMessage: msg
			});
		}
	}

	_getUserMessages(errCode){
		const mappings = this.getErrorCodeMappings();
		if(mappings && mappings[errCode]){
			return mappings[errCode];
		}
		return null;
	}

	/**
	 * @return {Object}
	 * 	A map that has the following structure
	 * 		{
	 * 			'Smarts-IRF_21' : {'title':<user friendly title>, 'description': <user friendly messages>},
	 * 			'ErrorCode': {'title':<user friendly title>, 'description': <user friendly messages>}
	 * 		}
	 */
	getErrorCodeMappings(){
		return null; //sub class to override
	}
}
export default SmartsRecommenderService;



// WEBPACK FOOTER //
// ./src/js/util/SmartsRecommenderService.js